import { render, staticRenderFns } from "./customerBooking.vue?vue&type=template&id=ea01fafa&scoped=true"
import script from "./customerBooking.vue?vue&type=script&lang=js"
export * from "./customerBooking.vue?vue&type=script&lang=js"
import style0 from "./customerBooking.vue?vue&type=style&index=0&id=ea01fafa&prod&scoped=true&lang=less"
import style1 from "./customerBooking.vue?vue&type=style&index=1&id=ea01fafa&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../../opt/deploy_node_modules/ailaworld/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ea01fafa",
  null
  
)

export default component.exports